import { render, staticRenderFns } from "./C-breadcrumb.vue?vue&type=template&id=56ea724e&scoped=true&"
import script from "./C-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./C-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./C-breadcrumb.vue?vue&type=style&index=0&id=56ea724e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea724e",
  null
  
)

export default component.exports